export enum SysLimiters {
    PasswordMinLength = 8,
    PasswordMaxLength = 255,
    B2bIdNumberMaxLength = 255,
}
